import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { GenericConfig } from '@signature-it/ngx-generic/config';

@Injectable({
    providedIn: 'root'
})

export class CookieDisclaimerService {

    static readonly APPROVE_COOKIE_DISCLAIMER = 'approve_cookie_disclaimer';

    public cookieDisclaimer$ = new BehaviorSubject(!GenericConfig.showCookieDisclaimer || this.getCookieDisclaimerType(CookieDisclaimerService.APPROVE_COOKIE_DISCLAIMER));
    public statusTypeArray: Array<{type: string, value: boolean}> = [];

    constructor(protected cookie: CookieService) { }

    setCookieDisclaimerCookie(){
        this.statusTypeArray.forEach((value) => {
            this.setCookieDisclaimerType(`${CookieDisclaimerService.APPROVE_COOKIE_DISCLAIMER}_${value.type}`, value.value);
        });
    }

    setCookieDisclaimerType(type, value){
        if(!this.getCookieDisclaimerType(type) || this.getCookieDisclaimerType(type) !== value) {
            let d = new Date();
            let month = d.getMonth();
            let day = d.getDate();
            let year = d.getFullYear();
            let expireDate = new Date(year + 1, month, day);
            this.cookie.set(type, value, expireDate);
        }
    }

    updateCookieDisclaimer(cookieDisclaimer) {
        this.setCookieDisclaimerType(CookieDisclaimerService.APPROVE_COOKIE_DISCLAIMER,true);
        this.cookieDisclaimer$.next(cookieDisclaimer);
    }

    getCookieDisclaimerType(type) {
        const val = this.cookie.get(type);
        return val ? Boolean(JSON.parse(val)) : false;
    }

    getCookieDisclaimer(type) {
        return this.getCookieDisclaimerType(`${CookieDisclaimerService.APPROVE_COOKIE_DISCLAIMER}_${type}`)
    }

    filterResourcesByCookie(resources) {
        return resources.filter(resource => !GenericConfig.showCookieDisclaimer || !resource['cookie_management'] || this.getCookieDisclaimerType(`${CookieDisclaimerService.APPROVE_COOKIE_DISCLAIMER}_${resource['cookie_management']}`));
    }
}
